
// import React from "react";
// import ReactDOM from "react-dom";

// const Modal = ({ isOpen, closeModal, heading, order }) => {
//     if (!isOpen) return null; // Don't render if modal is closed

//     return ReactDOM.createPortal(
//         <div style={modalStyles.overlay}>
//             <div style={modalStyles.modal}>
//                 <h2 style={modalStyles.sectionHeader}>{heading}</h2>
//                 <hr />
//                 {/* start */}

//                 <div style={modalStyles.content}>
//                     <div style={modalStyles.section}>
//                         <h3>Order Summary</h3>
//                         <p><strong>Order Number:</strong> {order.order_number}</p>
//                         <p><strong>Date:</strong> {new Date(order.created_at).toLocaleString()}</p>
//                         <p><strong>Status:</strong> {order.status.status}</p>
//                         <p><strong>Total:</strong> PKR {order.total}</p>
//                         <p><strong>Subtotal:</strong> PKR {order.subtotal}</p>
//                         <p><strong>Shipping Cost:</strong> PKR {order.shipping_cost}</p>
//                     </div>
//                     <div style={modalStyles.section}>
//                         <h3>Shipping Information</h3>
//                         <p><strong>Name:</strong> {order.first_name} {order.last_name}</p>
//                         <p><strong>Email:</strong> {order.email}</p>
//                         <p><strong>Phone:</strong> {order.phone}</p>
//                         <p><strong>Address:</strong> {order.address}, {order.city}</p>
//                         <p><strong>Postal Code:</strong> {order.postal_code}</p>
//                         <p><strong>Shipping Method:</strong> {order.shipping_method}</p>
//                     </div>
//                     <div style={modalStyles.section}>
//                         <h3>Billing Information</h3>
//                         <p><strong>Name:</strong> {order.billing_address_first_name} {order.billing_address_last_name}</p>
//                         <p><strong>Phone:</strong> {order.billing_phone}</p>
//                         <p><strong>Address:</strong> {order.billing_address_address}, {order.billing_city}</p>
//                         <p><strong>Postal Code:</strong> {order.billing_postal_code}</p>
//                         <p><strong>Country:</strong> {order.billing_address_country}</p>
//                     </div>
//                 </div>


//                 {/* end */}
                
//             <i onClick={closeModal} className="fa-solid fa-close" style={modalStyles.closeButton}> </i>
//             </div>
//         </div>,
//         document.body // Render the modal into the DOM body
//     );
// };

// // Inline styles for modal (you can replace with CSS classes)
// const modalStyles = {
//     overlay: {
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: "rgba(0, 0, 0, 0.5)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 1000,
//     },
//     modal: {
//         background: "#fff",
//         padding: "20px",
//         borderRadius: "8px",
//         width: "70%",
//         height: "calc(100vh - 200px)",
//         textAlign: "center",
//         boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
//     },
//     closeButton: {
//         position: "absolute",
//         top: "90px",
//         right: "210px",
//         padding: "5px",
//         backgroundColor: "red",
//         color: "white",
//         border: "none",
//         borderRadius: "50%",
//         cursor: "pointer",

        
//     },

//     section: {
//         marginBottom: "20px",
//     },
//     sectionHeader: {
//         fontSize: "18px",
//         marginBottom: "10px",
//         borderBottom: "1px solid #ddd",
//         paddingBottom: "5px",
//     },
// };

// export default Modal;


import React from "react";
import ReactDOM from "react-dom";
import OrderDetails from "./OrderDetails";
import ProductNotification from "./ProductNotification";

const Modal = ({ isOpen, closeModal, heading, data, dataMode }) => {
    if (!isOpen) return null;
    
    const renderBody = () => {
        switch (dataMode) {
            case "orderdetails":
                return <OrderDetails order={data} close={closeModal}/>;
            case "productNotification":
                return <ProductNotification dt={data} close={closeModal} />
            default:
                return <div> No Mode selected </div>;
        }
        return <div>{renderBody()}</div>;
    };

    

    return ReactDOM.createPortal(
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <button style={styles.closeButton} onClick={closeModal}>
                    &times;
                </button>
                <h2 style={styles.header}>{heading}</h2>
                {renderBody()}
            </div>
        </div>,
        document.body
    );
};

const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
    },
    modal: {
        background: "#fff",
        borderRadius: "10px",
        width: "90%",
        maxWidth: "700px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
        position: "relative",
        padding: "20px",
        maxHeight: "90vh",
        overflowY: "auto",
    },
    closeButton: {
        position: "absolute",
        top: "10px",
        right: "10px",
        background: "red",
        color: "white",
        border: "none",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
        cursor: "pointer",
        fontSize: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    header: {
        textAlign: "center",
        marginBottom: "20px",
        fontSize: "24px",
        color: "#333",
    },
    
};

export default Modal;
